import Card from 'react-bootstrap/Card'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'

import {
  attendanceTone,
  formatCurrency,
  formatInteger,
  formatPercent,
} from './attendanceIntelligenceUtils'

function KpiCard({ title, value, subtitle, tone = 'neutral' }) {
  return (
    <Card
      body
      className={`card--xs card-with-border attendance-kpi-card attendance-kpi-card--${tone}`}
    >
      <p className="attendance-kpi-card__label">{title}</p>
      <p className="attendance-kpi-card__value">{value}</p>
      {subtitle ? (
        <p
          className={`attendance-kpi-card__subtitle attendance-kpi-card__subtitle--${tone}`}
        >
          {subtitle}
        </p>
      ) : null}
    </Card>
  )
}

export default function AttendanceIntelligenceSummary({ kpis }) {
  if (!kpis) return null

  const tone = attendanceTone(kpis.attendanceRate)

  return (
    <div className="attendance-intelligence-summary">
      <h2 className="h5 mb-3">Overview</h2>
      <Row className="g-3">
        <Col sm={6} xl={3}>
          <KpiCard
            title="Tickets Sold"
            value={formatInteger(kpis.ticketsSold)}
            subtitle={`${formatInteger(kpis.ticketsUnscanned)} no-shows`}
            tone="neutral"
          />
        </Col>
        <Col sm={6} xl={3}>
          <KpiCard
            title="Tickets Scanned"
            value={formatInteger(kpis.ticketsScanned)}
            subtitle={`${formatPercent(kpis.noShowRate)} no-show rate`}
            tone={tone}
          />
        </Col>
        <Col sm={6} xl={3}>
          <KpiCard
            title="Attendance Rate"
            value={formatPercent(kpis.attendanceRate)}
            subtitle={
              kpis.attendanceRate >= 85
                ? 'Strong turnout'
                : kpis.attendanceRate >= 70
                  ? 'On track'
                  : 'Below target'
            }
            tone={tone}
          />
        </Col>
        <Col sm={6} xl={3}>
          <KpiCard
            title="No-Show Revenue Impact"
            value={formatCurrency(kpis.noShowRevenueImpact)}
            subtitle="Estimated lost ancillary revenue"
            tone={kpis.noShowRevenueImpact > 0 ? 'negative' : 'neutral'}
          />
        </Col>
      </Row>
    </div>
  )
}
